import type { Vehicle } from '@logistech/ui-shared';

// Aligné sur l'enum VehicleStatus (prisma/schema.prisma)
export const VEHICLE_STATUS_LABELS: Record<Vehicle['status'], string> = {
  ACTIVE: 'En service',
  MAINTENANCE: 'En maintenance',
  OUT_OF_SERVICE: 'Hors service',
  RETIRED: 'Retiré',
};

export const VEHICLE_STATUS_VARIANT: Record<Vehicle['status'], 'success' | 'warning' | 'destructive' | 'secondary'> = {
  ACTIVE: 'success',
  MAINTENANCE: 'warning',
  OUT_OF_SERVICE: 'destructive',
  RETIRED: 'secondary',
};

// Valeurs du formulaire de création (fleet.new)
export const FUEL_TYPE_LABELS: Record<string, string> = {
  DIESEL: 'Diesel',
  GASOLINE: 'Essence',
  ELECTRIC: 'Électrique',
  HYBRID: 'Hybride',
  CNG: 'GNV',
  LPG: 'GPL',
};

export const fuelLabel = (f: string | null): string => (f ? FUEL_TYPE_LABELS[f] ?? f : '—');
